/**
 * A value as JSON with its object keys in a fixed order, so two values that
 * say the same thing compare equal as text.
 *
 * Postgres `jsonb` does not keep the order keys were written in: it returns
 * them shortest first (`kind`, `field`, `children`, `operator`, `combinator`).
 * A saved view read from the API therefore serialises differently from the same
 * filter decoded from the URL, which builds `kind` then `combinator` then
 * `children`, and comparing them with `JSON.stringify` said they differed — the
 * picker never named the view that was open, and Save offered to overwrite a
 * view nobody had changed. Fixtures keep insertion order, which is why it only
 * showed on the real API, and only for a view stored there (#527, found when
 * the shared tracking views were opened from the picker).
 */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(sorted(value));
}

function sorted(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sorted);
  if (typeof value === "object" && value !== null) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
        .map(([key, entry]) => [key, sorted(entry)]),
    );
  }
  return value;
}
